module.exports = __webpack_public_path__ + "static/img/side-logo.a4387659.png";